import React, { createContext, useState, useContext, useEffect} from 'react';

const SearchQueryContext = createContext();

export function useAutoClearSearchQuery() {
  const { setSearchQuery } = useSearchQuery();

  useEffect(() => {
    // Clear on mount
    setSearchQuery("");

    return () => {
      // Clear on unmount
      setSearchQuery("");
    };
  }, []);
}

export function SearchQueryProvider({ children }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [isCourseSubMenuOpen,setIsCourseSebMenuOpen] = useState(true);
  const [isFeedbackModelOpen, setIsFeedbackModelOpen ] = useState(false);
  const [newFlag, setNewFlag] = useState(false);

  useEffect(() => {
    setSearchQuery(""); // Clear on mount
    return () => {
      setSearchQuery(""); // Clear on unmount
    };
  }, [window.location?.pathname]);

  return (
    <SearchQueryContext.Provider
      value={{
        searchQuery,
        setSearchQuery,
        isCourseSubMenuOpen,
        setIsCourseSebMenuOpen,
        isFeedbackModelOpen,
        setIsFeedbackModelOpen,
        newFlag,
        setNewFlag,
      }}
    >
      {children}
    </SearchQueryContext.Provider>
  );
}

export function useSearchQuery() {
  const context = useContext(SearchQueryContext);
  if (!context) {
    throw new Error('useSearchQuery must be used within a SearchQueryProvider');
  }
  return context;
}
